/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {Link, Outlet } from "react-router-dom";
import classes from "./index.module.scss";
import {ReactComponent as Onah} from "assets/svgs/onah_logo_light.svg";
import classNames from "classnames";
import { Routes } from "routes/routes";

type Props = {};

const AuthLayout: React.FC = (props: Props) => {

  return (
    <main className={classNames([classes.auth__layout, 'relative'])}>
      <div className="flex items-start w-full 2xl:px-[132px] px-[130px] mb-[60px] 2xl:mb-[62px]">
        <Link to={Routes.base}>
          <Onah className="z-10"/>
        </Link>
      </div>
      <div className="bg-white p-[30px] 2xl:p-[40px] rounded-[16px] 2xl:rounded-[22px] max-w-[512px] w-[95%] z-10">
        <Outlet />
      </div>
    </main>
  );
};

export default AuthLayout;
